
import barba from '@barba/core';
import PerfectScrollbar from 'perfect-scrollbar';

export default class{

	constructor(){
        
        barba.hooks.afterOnce((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        });
    }
    init(){
        const tabs = document.querySelectorAll('[data-overflow-x-scroll]')
		if(tabs.length > 0){
            tabs.forEach(t => {
                new PerfectScrollbar(t,{
                    wheelSpeed:1.5,
                    suppressScrollY:true
                })
            })
        }
    }

    
}